import { toast as F } from "@systemeio/ui";
import U from "axios";
import { useTranslation as w } from "../../../i18n.mjs";
import { createCanceler as y } from "../utils/create-canceler.mjs";
import { createProgress as T } from "../utils/create-progress.mjs";
import { getMimeType as v } from "../utils/get-mime-type.mjs";
import { useFileUploaderActions as P } from "./use-file-uploader-actions.mjs";
const G = (c) => {
  const { t: l } = w(), { validateAndGetUploadOptions: p, uploadToFileStore: m, activate: d, removeDraftFile: s } = P(c);
  return {
    createFileUploader: (f) => {
      const e = T(f), i = y();
      return {
        progress: e,
        upload: async ({ file: o, source: u }) => {
          e.startProgress();
          const a = i.createToken();
          let r;
          try {
            const { uploadOptions: t, id: n } = await p({
              file: o,
              source: u,
              mimeType: v(o),
              cancelToken: a
            });
            r = n, await m({
              file: o,
              uploadOptions: t,
              progressHandler: e.progressHandler,
              cancelToken: a
            });
            const g = await d({
              fileId: n,
              cancelToken: a
            });
            return e.finishProgress(), g[n];
          } catch (t) {
            if (U.isCancel(t)) {
              F(
                l("file_manager.cancelled", {
                  name: o.name
                })
              ), typeof r == "number" && await s(r);
              return;
            }
            throw typeof r == "number" && await s(r), t;
          }
        },
        cancelUpload: () => {
          i.cancel(), e.resetProgress();
        }
      };
    }
  };
};
export {
  G as useFileUploader
};
